import React, { useEffect } from 'react';
import { Box, Theme, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Header } from '@navigationMenu/Header';
import { GoodWelcome } from '@screens/welcomeToInter/GoodWelcome';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    background: '#f5f5f5',
    paddingBottom: '40px',
  },
}));

export const ZurichPayment: React.FC = () => {
  useEffect(() => {
    window.scroll(0,0);
  }, []);
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
        <Box
          sx={{ flexGrow: 1 }}
          style={{
            marginTop: 80,
            minHeight: '70vh',
            position: 'relative',
          }}
        >
          <Header title={'Pago referenciado'} subtitle="" />
          <GoodWelcome isZurich />
        </Box>
      </Container>
    </div>
  );
};
